import { createContext } from 'react';
export const CopilotChannelContext = /*#__PURE__*/createContext({
  channel: undefined,
  channelState: {
    appContext: {},
    isFileManagerOpen: false,
    isNavCopilotAvailable: false,
    isWidgetOpen: false,
    isWidgetActive: false,
    layoutType: 'panel',
    breezeContext: {
      messageContexts: [],
      context: {},
      turnMetadata: {},
      conversationMetadata: {},
      agentId: undefined
    }
  },
  instanceId: undefined
});